import styled from "styled-components";

const SingleItem = styled.li`
    border: none;
    border-bottom: 1px solid ${(props) => props.theme.colors.neutral.neutral50};
    cursor: pointer;
    display: flex;
    min-height: 40px;
    padding: ${(props) => props.theme.spacing.sm} ${(props) => props.theme.spacing.xs};
    font-size: ${(props) => props.theme.typography.body.medium.fontSize};
    margin: 0;
    line-height: ${(props) => props.theme.typography.body.medium.lineHeight};

    a {
        color: ${(props) => props.theme.colors.neutral.black};
    }

    @media (min-width: ${(props) => props.theme.layout.breakpoints.md}) {
        padding: ${(props) => props.theme.spacing.xs};
    }
`;

export default SingleItem;
